import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {headers} from "./headers";
import {host} from "./api";
import {getStorageProvider, StorageProvider, StorageProviderSettings} from "../../storage/providers/StorageProvider";


export interface StorageState {
    storageProviderSettings: StorageProviderSettings[],
    projectStorageProviderSettings: StorageProviderSettings | undefined
    storageProvider: StorageProvider | undefined
}

const initialState: StorageState = {
    storageProviderSettings: [],
    projectStorageProviderSettings: undefined,
    storageProvider: undefined
}

export const loadStorageSettings = createAsyncThunk('loadStorageSettings', async () => {
    const response = axios.get(`${host}/storage/providers`, {
        headers: headers(undefined)
    })
    return response.then((response) => response.data)
})

export const loadProjectStorageProvider = createAsyncThunk('loadProjectStorageProvider', async (params: {
    projectId: string | undefined
}) => {
    const response = axios.get(`${host}/storage/project/providers`, {
        headers: headers(params.projectId)
    })
    return response.then((response) => response.data)
})

export const saveStorageSettings = createAsyncThunk('saveStorageSettings', async (params: {
    settings: StorageProviderSettings[]
}) => {
    const response = axios.post(`${host}/storage/providers`, params.settings, {
        headers: headers(undefined)
    })
    return response.then((response) => response.data)
})

export const saveProjectStorageProvider = createAsyncThunk('saveProjectStorageProvider', async (params: {
    provider: StorageProviderSettings,
    projectId: string | undefined
}) => {
    const response = axios.post(`${host}/storage/project/providers`, params.provider, {
        headers: headers(params.projectId)
    })
    return response.then((response) => response.data)
})


export const storageSlice = createSlice({
    name: 'storage',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(loadStorageSettings.fulfilled, (state, action) => {
                state.storageProviderSettings = action.payload
            })
            .addCase(saveStorageSettings.fulfilled, (state, action) => {
                state.storageProviderSettings = action.payload
            })
            .addCase(loadProjectStorageProvider.fulfilled, (state, action) => {
                const providerSettings = JSON.stringify(action.payload) == '{}' ? undefined : action.payload
                state.storageProvider = getStorageProvider(providerSettings)
                state.projectStorageProviderSettings = providerSettings
            })
            .addCase(saveProjectStorageProvider.fulfilled, (state, action) => {
                state.projectStorageProviderSettings = JSON.stringify(action.payload) == '{}' ? undefined : action.payload
            })
    }
})


export default storageSlice.reducer;